/*
 * @Author: DT
 * @Date: 2022-07-01 16:49:05
 * @LastEditors: DT
 * @LastEditTime: 2022-07-28 15:42:15
 * @Description: file content
 * @FilePath: /yxdcommunity/src/store/user.js
 */
/* jshint esversion: 6 */
import utils from "../libs/utils";
import axios from "axios";
import Qs from "qs";
const group = "user";

const model = {
  LOGIN_IN: "", // 登录
  STORE_ID: "", // 登录用户ID
  USER_CUSTOME: "", // 登录人身份
};

export const types = utils.genTypes(model, group);
export const state = utils.genState(model, group);
export const getters = utils.genGetters(types);
export const mutations = utils.genMutations(types);

mutations[types.RESET] = (s) => {
  Object.keys(s).forEach((key) => {
    s[key] = state[key];
  });
};

const service = axios.create({
  timeout: 60000,
});
// 设置 post、put 默认 Content-Type
service.defaults.withCredentials = true;
service.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
service.defaults.headers.put["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
export const actions = {
  // 用户信息
  [types.LOGIN_IN](store, params) {
    // 用户名密码登录
    if (params.type === "account") {
      return service
        .post(
          `https://api.${process.env.VUE_APP_HOST}/ylxduser/fresh/user/login`,
          Qs.stringify(params.user)
        )
        .then((res) => {
          if (res) {
            if (res.data.returnCode === "0000") {
              res.code = "200";
            }
            return res;
          }
        });
    }
    // 短信验证码登录
    else if (params.type === "phone") {
      return service
        .post(
          `https://api.${process.env.VUE_APP_HOST}/ylxduser/fresh/user/quickLogin`,
          Qs.stringify(params.user)
        )
        .then((res) => {
          if (res) {
            if (res.data.returnCode === "0000" && res.data.data) {
              res.code = "200";
            }
            return res;
          }
        });
    }
  },
};
